import RfiCreate from './RfiCreate.page';

export default RfiCreate;
